<template>
  <div id="order-table-type-icon">
    <div class="items-flex">
      <!-- FORKED ICONS -->
      <div class="forked-icons">
        <template v-if="item.forkedTo || item.forkedFrom">
          <v-tooltip top max-width="300px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="#999" class="mr-1" v-bind="attrs" v-on="on">
                mdi-directions-fork
              </v-icon>
            </template>
            <span>{{ $t(`views.common.orderTableTypeIcon.forked`) }}</span>
          </v-tooltip>
        </template>
      </div>
      <!-- ------------- -->

      <v-tooltip top max-width="300px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="iconSize" :color="color" v-on="on">
            {{ icon }}
          </v-icon>
        </template>
        <span v-if="item.createdFromFxOrder">
          {{ $t(`views.dashboardDetail.coreOrders.coreOrdersTable.fromFxOrder.${item.type}`) }}
        </span>
        <span v-else>
          {{
            !createdFromSwitchOrder
              ? $t(`views.common.orderTableTypeIcon.${item.type}`)
              : item.notGp
              ? $t(`views.common.orderTableTypeIcon.fromSwitch.notGp.${item.type}`)
              : $t(`views.common.orderTableTypeIcon.fromSwitch.gp.${item.type}`)
          }}
        </span>

        <span v-if="item.type === 'split'">{{ ` ${item.metadata.split}` }}</span>
      </v-tooltip>

      <TableImportIcon :item="item" />
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { ORDERS_TYPE_PALETTE } from '@/lib/colors.js'
import TableImportIcon from '@/views/components/common/TableImportIcon'

export default {
  components: { TableImportIcon },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    createdFromSwitchOrder() {
      return get(this.item, 'metadata.createdFromSwitchOrder', false)
    },
    icon() {
      if (this.createdFromSwitchOrder) return 'mdi-circle-multiple'

      if (this.item.createdFromFxOrder) {
        if (this.item.type === 'buy') return 'mdi-cash-plus'
        else if (this.item.type === 'sell') return 'mdi-cash-minus'
      }

      if (this.item.type === 'buy') return 'mdi-plus-circle-multiple-outline'
      else if (this.item.type === 'bonus') return 'mdi-gift-outline'
      else if (this.item.type === 'stakeReward') return 'mdi-hand-coin-outline'
      else if (this.item.type === 'drip') return 'mdi-chart-box-plus-outline'
      else if (this.item.type === 'sell') return 'mdi-minus-circle-multiple-outline'
      else if (this.item.type === 'switch') return 'mdi-circle-multiple'
      else if (this.item.type === 'switchBuy') return 'mdi-circle-multiple'
      else if (this.item.type === 'spinOff') return 'mdi-set-split'
      else if (this.item.type === 'spinOffBuy') return 'mdi-plus-circle-multiple-outline'
      else if (this.item.type === 'split') return 'mdi-call-split'
      else if (this.item.type === 'brokerTransfer') return 'mdi-bank-transfer'
      else if (this.item.type === 'sharePremium') return 'mdi-handshake-outline'
      else if (this.item.type === 'capitalIncrease') return 'mdi-briefcase-upload-outline'
      else if (this.item.type === 'scrip') return 'mdi-piggy-bank-outline'
      else if (this.item.type === 'deposit') return 'mdi-bank-plus'
      else if (this.item.type === 'withdrawal') return 'mdi-bank-minus'
      else if (this.item.type === 'commission') return 'mdi-bank-remove'
      else if (this.item.type === 'paidInterest') return 'mdi-bank-minus'
      else if (this.item.type === 'interest') return 'mdi-bank-check'
      else if (this.item.type === 'interestRetention') return 'mdi-home-remove-outline'
      else if (this.item.type === 'optionBuy') return 'mdi-plus-box-multiple-outline'
      else if (this.item.type === 'optionSell') return 'mdi-minus-box-multiple-outline'
      return null
    },
    iconSize() {
      if (this.item.type === 'bonus') return 17

      if (this.item.createdFromFxOrder) return 21

      return 18
    },
    color() {
      if (this.item.type === 'sell') {
        if (this.createdFromSwitchOrder) return ORDERS_TYPE_PALETTE.switch
        else return ORDERS_TYPE_PALETTE.sell
      } else {
        return ORDERS_TYPE_PALETTE[this.item.type]
      }
    },
  },
}
</script>

<style lang="scss">
#order-table-type-icon {
  .items-flex {
    display: flex;
    align-items: center;
  }
  .forked-icons {
    display: flex;
    flex-direction: column;
  }
}
</style>
